import { createSlice } from "@reduxjs/toolkit";
import {
  createCrudAccess,
  createTeacherUser,
  createUser,
  fetchOrgUsersById,
  fetchUserCrudAccess,
  GetCountRestrictionsThunk,
  GetCountRestrictionsThunk2,
  GetUserAccessThunk,
  GetUserAccessThunk2,
  updateTeacherUser,
} from "./userThunk";

const userSlice = createSlice({
  name: "user",
  initialState: {
    formData: {
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      role_id: "",
      teacher_id: "",
      dob: "",
      studentClass: "",
      contact_number: "",
    },
    showPassword: false,
    showConfirmPassword: false,
    showForm: false,
    status: "idle",
    error: null,
    users: [],
    loading: false,
    showPopup: false,
    selectedUserId: null,
    crudAccessData: null,
    userAccessData: {},
    userCountRestrictions: {},
    userAccessData2: {},
    userCountRestrictions2: {},
  },
  reducers: {
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },
    togglePasswordVisibility: (state, action) => {
      const field = action.payload;
      state[field] = !state[field];
    },
    handlePopup: (state, action) => {
      state.showForm = action.payload;
    },
    handleShowPopup: (state, action) => {
      // state.showPopup = action.payload;
      state.showPopup = action.payload.show;
      state.selectedUserId = action.payload.userId;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createUser.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(createUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchOrgUsersById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrgUsersById.fulfilled, (state, action) => {
        state.loading = false;
        console.log("action_payload: ", action.payload);
        state.users = action.payload;
        // if (JSON.stringify(state.users) !== JSON.stringify(action.payload)) {
        //   state.users = action.payload;
        // }
      })
      .addCase(fetchOrgUsersById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCrudAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCrudAccess.fulfilled, (state) => {
        state.loading = false;
        state.showPopup = false;
      })
      .addCase(createCrudAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(fetchUserCrudAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserCrudAccess.fulfilled, (state, action) => {
        state.loading = false;
        state.crudAccessData = action.payload;
      })
      .addCase(fetchUserCrudAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch CRUD access";
      })
      .addCase(createTeacherUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTeacherUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createTeacherUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch CRUD access";
      })
      .addCase(updateTeacherUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTeacherUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTeacherUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch CRUD access";
      })
      .addCase(GetUserAccessThunk2.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetUserAccessThunk2.fulfilled, (state, action) => {
        state.loader = false;
        state.userAccessData2 = action.payload[0];
      })
      .addCase(GetUserAccessThunk2.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to User access";
      })
      .addCase(GetCountRestrictionsThunk2.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetCountRestrictionsThunk2.fulfilled, (state, action) => {
        state.loader = false;
        state.userCountRestrictions2 = action.payload;
      })
      .addCase(GetCountRestrictionsThunk2.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to User access";
      });

    builder
      .addCase(GetUserAccessThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetUserAccessThunk.fulfilled, (state, action) => {
        state.loader = false;
        state.userAccessData = action.payload[0];
      })
      .addCase(GetUserAccessThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to User access";
      });

    builder
      .addCase(GetCountRestrictionsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetCountRestrictionsThunk.fulfilled, (state, action) => {
        state.loader = false;
        state.userCountRestrictions = action.payload;
      })
      .addCase(GetCountRestrictionsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to User access";
      });
  },
});

export const {
  updateFormField,
  togglePasswordVisibility,
  handlePopup,
  handleShowPopup,
} = userSlice.actions;
export default userSlice.reducer;
